import PropTypes from "prop-types";
import styles from "./CustomTabs.module.css";

const CustomTabs = ({items, activeKey, onChange}) => {
  return (
    <div className={styles.customTabs}>
      <div className={styles.tabHeader}>
        {items.map(item => (
          <button
            key={item.key}
            type="button"
            className={`${styles.tabButton} ${activeKey === item.key ? styles.active : ""}`}
            onClick={() => onChange(item.key)}
          >
            {item.label}
          </button>
        ))}
      </div>
      <div className={styles.tabContent}>{items.find(item => item.key === activeKey)?.children}</div>
    </div>
  );
};

CustomTabs.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.node.isRequired,
      children: PropTypes.node.isRequired,
    })
  ).isRequired,
  activeKey: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default CustomTabs;
